import { useEffect, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import { Alert, Stack, Typography } from '@mui/material'

import { useTexts } from '../../useTexts'

import { form } from '../../formState'

interface Props {
  notificationBehavior: uui.domain.client.rm.NotificationBehavior
}

export function NotificationWay(props: Props) {
  const { notificationBehavior } = props

  const texts = useTexts()
  const formApi = form.useFormApi()

  const options = useMemo(() => {
    return [
      {
        value: 'EMAIL' as uui.domain.client.rm.NotificationWay,
        label: texts.email,
        // EMAIL option should, theoretically, never be disabled because
        // if the notification behavior is NO_NOTIFICATIONS, the entire section won't be visible.
        disabled: notificationBehavior === 'NO_NOTIFICATIONS',
      },
      {
        value: 'PHONE' as uui.domain.client.rm.NotificationWay,
        label: texts.sms,
        disabled: notificationBehavior !== 'EMAIL_AND_PHONE',
      },
    ]
  }, [texts, notificationBehavior])

  useEffect(() => {
    const unsubscribe = formApi.subscribeToField('notificationWay', field => {
      // SUBJECT must be visible and required for EMAIL notifications
      formApi.setFieldVisibleState('subjectCustom', field.value === 'EMAIL')

      // EMAIL BACKUP must be invisible for EMAIL notifications
      formApi.setFieldVisibleState('backupNotification', field.value === 'PHONE')

      // Validate templateCustom field when notification type changes as some hotwords are required only for Phone
      formApi.validate('templateCustom')
    })

    return () => {
      unsubscribe()
    }
  }, [formApi])

  return (
    <Stack>
      <form.RadioGroup
        label={texts.notificationWayLabel}
        validateOn="focus blur"
        name="notificationWay"
        testId="notificationWay"
        options={options}
      />

      {notificationBehavior === 'ONLY_EMAIL' ? (
        <Alert severity="info">
          <FormattedMessage
            id={texts.smsEnableConditionMessage}
            values={{
              b: chunks => (
                <Typography fontWeight={600} display="inline" fontSize="inherit">
                  {chunks}
                </Typography>
              ),
            }}
          />
        </Alert>
      ) : (
        <></>
      )}
    </Stack>
  )
}
